'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _common = require('../common');

var _commonFormsy = require('../common-formsy');

var _constants = require('../../constants');

var _mightyFields = require('../../lib/mighty-fields');

var _CapitalFundingForm = require('./main-details/capital-fundings/CapitalFundingForm');

var _CapitalFundingForm2 = _interopRequireDefault(_CapitalFundingForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PERMISSIONS = _constants.AppConstants.PERMISSIONS;


var DEFAULT_LABEL = 'Signed Contract',
    REF_LIEN_DOCUMENT = 'section-lien-document',
    REF_CAPITAL_PROVIDERS = 'section-capital-providers',
    REF_FOLLOWUP_DATE = 'section-followup-date',
    REF_AVAILABLE_COOP = 'section-available-coop';

var PostFundingModal = (_dec = (0, _mobxReact.inject)('CaseStore', 'FunderStore', 'LienStore', 'SessionStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(PostFundingModal, _Component);

  function PostFundingModal(props) {
    _classCallCheck(this, PostFundingModal);

    var _this = _possibleConstructorReturn(this, (PostFundingModal.__proto__ || Object.getPrototypeOf(PostFundingModal)).call(this, props));

    _this.steps = [];

    _initDefineProp(_this, 'step', _descriptor, _this);

    _initDefineProp(_this, 'lien', _descriptor2, _this);

    _initDefineProp(_this, 'lienDocumentLabel', _descriptor3, _this);

    _initDefineProp(_this, 'lienDocumentFile', _descriptor4, _this);

    _initDefineProp(_this, 'trackingDate', _descriptor5, _this);

    _initDefineProp(_this, 'uploading', _descriptor6, _this);

    _initDefineProp(_this, 'isAvailableToCoop', _descriptor7, _this);

    var FunderStore = props.FunderStore,
        SessionStore = props.SessionStore;


    _this.steps = [];
    _this.steps.push(_this.renderLienDocumentUploadStep);
    if (FunderStore.canSeeCapitalProviders && SessionStore.userHasPermission(PERMISSIONS.EDIT_CAPITAL_PROVIDER)) {
      _this.steps.push(_this.renderCapitalProvidersStep);
    }
    _this.steps.push(_this.renderTrackingFollowUpDateStep);
    if (FunderStore.isFinanceCustomer) {
      _this.steps.push(_this.renderIsAvailableCoopStep);
    }
    return _this;
  }

  _createClass(PostFundingModal, [{
    key: 'handleLienDocumentUpload',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(model, resetForm, invalidateForm) {
        var _props, LienStore, lien;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, LienStore = _props.LienStore, lien = _props.lien;

                this.uploading = true;
                _context.next = 4;
                return LienStore.createLienDocument({ data: model, lienId: lien.id });

              case 4:
                this.uploading = false;
                this.incrementStep();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleLienDocumentUpload(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return handleLienDocumentUpload;
    }()
  }, {
    key: 'handleIsAvailableCoopSubmit',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(model) {
        var _props2, CaseStore, LienStore, lien, UiStore;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props2 = this.props, CaseStore = _props2.CaseStore, LienStore = _props2.LienStore, lien = _props2.lien, UiStore = _props2.UiStore;
                _context2.next = 3;
                return LienStore.update(lien, model);

              case 3:
                _context2.next = 5;
                return CaseStore.refresh(lien.case);

              case 5:

                UiStore.modals.PostFunding.close();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleIsAvailableCoopSubmit(_x4) {
        return _ref2.apply(this, arguments);
      }

      return handleIsAvailableCoopSubmit;
    }()
  }, {
    key: 'handleTrackingFollowUpDateSubmit',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(model, resetForm, invalidateForm) {
        var _props3, CaseStore, caseId;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _props3 = this.props, CaseStore = _props3.CaseStore, caseId = _props3.caseId;
                _context3.next = 3;
                return CaseStore.update({ caseId: caseId, data: model });

              case 3:

                this.incrementStep();

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleTrackingFollowUpDateSubmit(_x5, _x6, _x7) {
        return _ref3.apply(this, arguments);
      }

      return handleTrackingFollowUpDateSubmit;
    }()
  }, {
    key: 'incrementStep',
    value: function incrementStep() {
      var UiStore = this.props.UiStore;

      this.step++;
      if (this.step >= this.steps.length) {
        UiStore.modals.PostFunding.close();
      }
    }
  }, {
    key: 'isStepComplete',
    value: function isStepComplete(idx) {
      return this.step > idx;
    }
  }, {
    key: 'isCurrentStep',
    value: function isCurrentStep(idx) {
      return this.step === idx;
    }
  }, {
    key: 'onLienDocumentLabelChange',
    value: function onLienDocumentLabelChange(lienDocumentLabel) {
      this.lienDocumentLabel = lienDocumentLabel;
    }
  }, {
    key: 'onLienDocumentFileChange',
    value: function onLienDocumentFileChange(lienDocumentFile) {
      this.lienDocumentFile = lienDocumentFile;
    }
  }, {
    key: 'onTrackingDateChange',
    value: function onTrackingDateChange(trackingDate) {
      this.trackingDate = trackingDate;
    }
  }, {
    key: 'onIsAvailableToCoopChange',
    value: function onIsAvailableToCoopChange(isAvailableToCoop) {
      this.isAvailableToCoop = isAvailableToCoop;
    }
  }, {
    key: 'renderLienDocumentUploadStep',
    value: function renderLienDocumentUploadStep(idx) {
      return _react2.default.createElement(
        'div',
        { key: idx, className: 'section', ref: REF_LIEN_DOCUMENT },
        this.renderStepDot(idx),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Upload Signed Contract'
          ),
          this.isCurrentStep(idx) && _react2.default.createElement(
            _commonFormsy.Form,
            { onValidSubmit: this.handleLienDocumentUpload },
            _react2.default.createElement(_commonFormsy.Input, {
              label: 'Document Label',
              name: 'name',
              onChange: this.onLienDocumentLabelChange,
              required: true,
              type: 'text',
              value: this.lienDocumentLabel
            }),
            _react2.default.createElement(_commonFormsy.File, {
              label: 'File',
              name: 'file',
              onChange: this.onLienDocumentFileChange,
              required: true
            }),
            _react2.default.createElement(
              _ButtonToolbar2.default,
              null,
              _react2.default.createElement(
                _Button2.default,
                { bsStyle: 'primary', type: 'submit', disabled: !this.isLienUploadValid || this.uploading },
                this.uploading ? 'Uploading...' : 'Upload & Continue'
              ),
              _react2.default.createElement(
                _Button2.default,
                { onClick: this.incrementStep },
                'Skip'
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderCapitalProvidersStep',
    value: function renderCapitalProvidersStep(idx) {
      return _react2.default.createElement(
        'div',
        { key: idx, className: 'section', ref: REF_CAPITAL_PROVIDERS },
        this.renderStepDot(idx),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Add Capital Providers to Lien'
          ),
          this.isCurrentStep(idx) && _react2.default.createElement(
            'div',
            { className: 'section-providers' },
            _react2.default.createElement(_CapitalFundingForm2.default, {
              lienId: this.props.lien.id,
              cancelText: 'Skip',
              onClose: this.incrementStep
            })
          )
        )
      );
    }
  }, {
    key: 'renderTrackingFollowUpDateStep',
    value: function renderTrackingFollowUpDateStep(idx) {
      return _react2.default.createElement(
        'div',
        { key: idx, className: 'section', ref: REF_FOLLOWUP_DATE },
        this.renderStepDot(idx),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Schedule Case Tracking Follow-Up'
          ),
          this.isCurrentStep(idx) && _react2.default.createElement(
            _commonFormsy.Form,
            { onValidSubmit: this.handleTrackingFollowUpDateSubmit },
            _react2.default.createElement(
              'p',
              { className: 'form-copy' },
              'Case tracking is the practice of loss prevention by routinely checking in with \
                  the law firm to ensure your lien isn\'t missed and the attorney is still \
                  representing the plaintiff.'
            ),
            _react2.default.createElement(_commonFormsy.DateInput, {
              label: 'Schedule Case Tracking',
              name: 'tracking_follow_up_date',
              onChange: this.onTrackingDateChange,
              positionTop: true,
              required: true
            }),
            _react2.default.createElement(
              _ButtonToolbar2.default,
              null,
              _react2.default.createElement(
                _Button2.default,
                { bsStyle: 'primary', type: 'submit', disabled: !this.isTrackingDateValid },
                'Save'
              ),
              _react2.default.createElement(
                _Button2.default,
                { onClick: this.incrementStep },
                'Skip'
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderIsAvailableCoopStep',
    value: function renderIsAvailableCoopStep(idx) {
      return _react2.default.createElement(
        'div',
        { key: idx, className: 'section', ref: REF_AVAILABLE_COOP },
        this.renderStepDot(idx),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Set Lien Available For Purchase By CoOp Capital'
          ),
          this.isCurrentStep(idx) && _react2.default.createElement(
            _commonFormsy.Form,
            { onValidSubmit: this.handleIsAvailableCoopSubmit },
            _react2.default.createElement(_mightyFields.FormFieldSets, {
              fieldSets: [[{ field: 'is_available_to_coop', label: 'Available To CoOp Capital', type: 'boolean' }]],
              onChange: this.onIsAvailableToCoopChange,
              type: 'boolean',
              value: this.isAvailableToCoop
            }),
            _react2.default.createElement(
              _ButtonToolbar2.default,
              null,
              _react2.default.createElement(
                _Button2.default,
                { bsStyle: 'primary', type: 'submit' },
                'Save'
              ),
              _react2.default.createElement(
                _Button2.default,
                { onClick: this.incrementStep },
                'Skip'
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderStepDot',
    value: function renderStepDot(idx) {
      var dotClass = this.isCurrentStep(idx) ? 'active dot' : 'inactive dot',
          dotContent = !this.isStepComplete(idx) ? idx + 1 : _react2.default.createElement(_common.Icon, { type: 'check' });

      return _react2.default.createElement(
        'div',
        { className: dotClass },
        dotContent
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          title = _props4.title,
          UiStore = _props4.UiStore;


      return _react2.default.createElement(
        _Modal2.default,
        { show: true, onHide: UiStore.modals.PostFunding.close, className: 'post-funding-modal' },
        _react2.default.createElement(
          _Modal2.default.Header,
          { closeButton: true },
          _react2.default.createElement(
            _Modal2.default.Title,
            null,
            title
          )
        ),
        _react2.default.createElement(
          _Modal2.default.Body,
          null,
          _react2.default.createElement(
            'p',
            null,
            'You may upload a signed contract, other lien documents or schedule a case tracking follow-up at any time. These steps are optional.'
          ),
          _react2.default.createElement(
            'div',
            { className: 'sections' },
            this.steps.map(function (step, idx) {
              return step(idx);
            })
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'isLienUploadValid',
    get: function get() {
      return !!this.lienDocumentLabel && !!this.lienDocumentFile;
    }
  }, {
    key: 'isTrackingDateValid',
    get: function get() {
      return !!this.trackingDate;
    }
  }]);

  return PostFundingModal;
}(_react.Component), _class3.defaultProps = {
  title: 'Post Funding Steps'
}, _class3.propTypes = {
  caseId: _propTypes2.default.string.isRequired,
  CaseStore: _propTypes2.default.object.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  lien: _propTypes2.default.object,
  LienStore: _propTypes2.default.object.isRequired,
  SessionStore: _propTypes2.default.object.isRequired,
  title: _propTypes2.default.string,
  UiStore: _propTypes2.default.object.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'step', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'lien', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'lienDocumentLabel', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return DEFAULT_LABEL;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'lienDocumentFile', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'trackingDate', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'uploading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'isAvailableToCoop', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'incrementStep', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'incrementStep'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isLienUploadValid', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'isLienUploadValid'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isTrackingDateValid', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'isTrackingDateValid'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = PostFundingModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PERMISSIONS, 'PERMISSIONS', '/app/src/components/page-case/PostFundingModal.js');
  reactHotLoader.register(DEFAULT_LABEL, 'DEFAULT_LABEL', '/app/src/components/page-case/PostFundingModal.js');
  reactHotLoader.register(REF_LIEN_DOCUMENT, 'REF_LIEN_DOCUMENT', '/app/src/components/page-case/PostFundingModal.js');
  reactHotLoader.register(REF_CAPITAL_PROVIDERS, 'REF_CAPITAL_PROVIDERS', '/app/src/components/page-case/PostFundingModal.js');
  reactHotLoader.register(REF_FOLLOWUP_DATE, 'REF_FOLLOWUP_DATE', '/app/src/components/page-case/PostFundingModal.js');
  reactHotLoader.register(REF_AVAILABLE_COOP, 'REF_AVAILABLE_COOP', '/app/src/components/page-case/PostFundingModal.js');
  reactHotLoader.register(PostFundingModal, 'PostFundingModal', '/app/src/components/page-case/PostFundingModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/PostFundingModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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